<!-- ENDEREÇO -->
<mat-toolbar class="titulopartes">
    Endereço
</mat-toolbar>


<div fxLayoutAlign="end end">
    <a mat-button role="button" (click)="copiarEnderecoBeneficiario()" *ngIf="apresentaCopiarEndereco">
        <mat-icon>add_business</mat-icon>Copiar endereço do beneficiário
    </a>
    <a mat-button role="button" href="http://www.buscacep.correios.com.br/" target="_blank">
        <mat-icon>open_in_new</mat-icon>Buscar CEP
    </a>
</div>

<div fxLayout="row" class="espaco" fxLayoutGap="20px"
     style="margin-top: 10px; margin-bottom: 10px"
     fxFlexFill>

    <mat-form-field fxFlex="15%" fxFlexOffset="20px">
         <input type="text" matInput
                [(ngModel)]="dadosEndereco.cep"
                name="cep"
                placeholder="CEP"
                (change)="onChangeCep()"
                [textMask]="{mask: maskCep}"
                pattern="^\d{2}\.?\d{3}-?\d{3}$" />
    </mat-form-field>

    <mat-form-field fxFlex="45%">
        <input #campoEndereco
                matInput maxlength="200"
                [(ngModel)]="dadosEndereco.endereco"
                name="endereco"
                placeholder="Endereço"
                [required]="obrigatorio">
        <mat-hint align="end">{{campoEndereco.value.length}} / 200</mat-hint>
    </mat-form-field>

    <mat-form-field fxFlex="40%">
        <input #campoComplementoEndereco
                matInput maxlength="100"
                [(ngModel)]="dadosEndereco.complementoEndereco"
                name="complementoEndereco"
                placeholder="Complemento">
        <mat-hint align="end">{{campoComplementoEndereco.value.length}} / 100</mat-hint>
    </mat-form-field>

    <mat-form-field fxFlex="40%">
        <input #campoPontoReferencia
                matInput maxlength="200"
                [(ngModel)]="dadosEndereco.pontoReferencia"
                name="pontoReferencia"
                placeholder="Ponto de Referência">
                <mat-hint align="end">{{campoPontoReferencia.value.length}} / 200</mat-hint>
    </mat-form-field>

</div>

<div fxLayout="row" class="espaco" fxLayoutGap="20px"
     style="margin-top: 10px; margin-bottom: 10px"
     fxFlexFill>

     <mat-form-field fxFlex="45%" fxFlexOffset="20px">
        <input #campoCidade
               matInput maxlength="200"
               [(ngModel)]="dadosEndereco.cidade"
               name="cidade"
               [required]="obrigatorio"
               placeholder="Cidade">
        <mat-hint align="end">{{campoCidade.value.length}} / 200</mat-hint>
    </mat-form-field>

    <mat-form-field fxFlex="45%">
        <input #campoBairro
               matInput maxlength="200"
               [(ngModel)]="dadosEndereco.bairro"
               name="bairro"
               placeholder="Bairro">
        <mat-hint align="end">{{campoBairro.value.length}} / 200</mat-hint>
    </mat-form-field>

    <div ngModelGroup="comboUf" fxFlex="50">
        <combo-uf fxFlex="10%"
            [selecionado]="dadosEndereco.uf"
            [obrigatorio]="obrigatorio"
            (valorChange)="onUfChange($event)">
        </combo-uf>
    </div>

</div>



